import React from "react";
import { Link, useHistory } from "react-router-dom";
import btnStyles from "../styles/Button.module.css";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styles from "../styles/Account.module.css";

export default function TermsAndConditions() {
  const history = useHistory();

  return <>
  <div className="px-3">
  <h3 className="text-center py-4 w-100 mt-2"
        style={{
          // background: "#3B444A",
          background: "#39606e",
          color: "#F5F5F5",
          // fontFamily: "Playfair Display",
          textTransform: "uppercase",
        }}
      >
        Terms of Service
  </h3>
  {/* back button */}
  <Row className="mt-1">
    <Col xs={6} className="">
    <Button
        className={`${btnStyles.Button} ${btnStyles.Blue}`}
        onClick={() => history.goBack()}
      >
        Back
    </Button>
    </Col>
  </Row>
  <Row className="mt-1">
  <Col md={{span: 10, offset: 1}} className="mb-5">
  <h5 className="mt-5">The following terms of service (“<span className={`${styles.Bold} mb-0`}>Terms of Service</span>” or “<span className={`${styles.Bold} mb-0`}>Terms</span>) 
    govern the relationship between the user and <span className={`${styles.Bold} mb-0`}>FirstSlate Limited</span>, 
    incorporated under the laws of Ireland (CRO. Registered number [    ]), 
    with registered address [     ] (“<span className={`${styles.Bold} mb-0`}>FirstSlate</span>”,
     “<span className={`${styles.Bold} mb-0`}>us</span>”, “<span className={`${styles.Bold} mb-0`}>we</span>” 
     and <span className={`${styles.Bold}`}>our</span>), and should be read carefully in conjunction with 
     the <Link className={styles.Link1} to="/privacy-policy">
      Privacy Policy
      </Link>.
  </h5>

  <h3 className="mt-5 mb-3"><span className={`${styles.Bold}`}>1.  General</span></h3>
  <h5><span className={`${styles.Bold} mb-0`}>1.1</span> - <span className={`${styles.Bold}`}>FirstSlate Limited</span> shall provide, 
  via browser access, and in accordance with Clause 1.2:
  </h5>
  <h5 className="mt-3 pl-5"><span className={`${styles.Bold} mb-0`}>i.</span>	software for production managers (“<span className={`${styles.Bold} mb-0`}>Primary User</span>”) to 
  administer and budget video, television and film production 
  projects (“<span className={`${styles.Bold} `}>FirstSlate</span>”); and
  </h5>
  <h5 className="mt-3 pl-5">
  <span className={`${styles.Bold} mb-0`}>ii.</span>	software for cast, crew  (“<span className={`${styles.Bold} mb-0`}>Crew User</span>”) and Primary Users for, among other things, 
  planning, designing, scheduling, preparing and issuing call sheets, 
  crew administration and collaborating with others for production (“<span className={`${styles.Bold} mb-0`}>FirstSlate</span>”). 
  Crew Users shall be registered by production administrative 
  personnel (“<span className={`${styles.Bold} mb-0`}>Administrative User</span>”), 
  who themselves shall be registered by the Primary User.
  </h5>
  <h5 className="mt-3 pl-5">
  (together the “<span className={`${styles.Bold} mb-0`}>Production Software</span>”)
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>1.2</span>	- The Primary User, along with any Crew Users and Administrative Users (the “Users”) will access the Production Software at the 
  provided URL for any given Project.
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>1.3	</span>- Unless stated otherwise, any term defined anywhere in these 
  Terms of Service shall have the same meaning whether used in singular or plural.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>2.	Subscriptions</span>
  </h3>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>2.1</span>	- The Primary User may purchase a subscription to use FirstSlate, 
  which depending on the subscription plan may include access to discrete services 
  such as budgeting (“<span className={`${styles.Bold} mb-0`}>Discrete Subscription</span>”), or full 
  access to the Production Software (the “<span className={`${styles.Bold} mb-0`}>Platform Subscription</span>,” and 
  together with the Discrete Subscription, “<span className={`${styles.Bold} mb-0`}>Subscriptions</span>”).
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>2.2</span>	- Subscription services and plans are subject to change from time-to-time at FirstSlate’s sole 
  discretion. Please see FirstSlate’s Subscriptions 
  page for the latest information on available services and Subscription plans.
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>2.3</span>	- Payments shall be processed automatically to the chosen payment method monthly and will automatically renew each month, unless 
  terminated in accordance with Clause 9 (the “<span className={`${styles.Bold} mb-0`}>Term</span>”).
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>2.4</span>	- The Term of the Subscription shall commence following a 30-day free 
  trial (“<span className={`${styles.Bold} mb-0`}>Free Trial</span>”). After 30 days, and unless terminated in accordance 
  with Clause 9, the Free Trial shall automatically convert to a Subscription. 
  The first subscription payment will automatically be charged to the payment 
  method provided by the Primary User.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>2.5</span>	- Subscription payments are processed by a third-party provider 
    and are subject to Clause 6 and the <a className={styles.Link}
                          href="https://stripe.com/legal/ssa"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Stripe Services Agreement
                        </a>.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>2.6</span>	- Each Primary User shall be permitted to hold:
  </h5>
  <h5 className="mt-3 pl-5">
   <span className={`${styles.Bold} mb-0`}>2.6.1</span>- one Discrete Subscription; and
  </h5>
  <h5 className="mt-3 pl-5">
   <span className={`${styles.Bold} mb-0`}>2.6.2</span>	- one Platform Subscription.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>3.	Intellectual Property</span>
  </h3>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>3.1</span>	- The intellectual property 
  rights in relation to the Content may include 
  patents, copyright and neighbouring and related rights, trade marks, business 
  names and domain names, rights in get-up and trade dress, goodwill and the right 
  to sue for passing off or unfair competition, rights in designs, rights in 
  computer software, database rights, rights to use, and protect the confidentiality 
  of, confidential information (including know-how and trade secrets) and all other 
  intellectual property rights, in each case whether registered or 
  unregistered (“<span className={`${styles.Bold} mb-0`}>IP Rights</span>”).
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>3.2</span>	- The User agrees and 
  acknowledges that IP Rights subsisting in the content, 
  graphics, icons, logos, typography design, audio, source code, object code, 
  layouts, screen displays, graphical user interfaces (GUIs), animations and 
  databases of the Production Software (“<span className={`${styles.Bold} mb-0`}>Content</span>”) belong to FirstSlate 
  and its third-party licensors, who retain sole ownership rights, title, interest 
  and IP Rights in the Content.
  </h5>
  <h5 className="mt-3">
   <span className={`${styles.Bold} mb-0`}>3.3</span> - FirstSlate
   grants the User a non-exclusive, 
   non-transferable and non-sublicensable licence, subject to Clause 3.4, to use 
   the Production Software for the purpose of producing and creating video, 
   television and film productions, for the duration of the Term. 
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>3.4</span>	- The scope of the licence granted under Clause 3.3, and the services provided, 
  shall be determined by the nature of the Subscription purchased in Clause 2.1. 
  Licenses granted to Crew Users and Administrative Users may be restricted by the 
  Primary User with permissions and access rights, which may be updated or disabled 
  at the Primary User’s discretion.
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>3.5</span>	- The User may upload or generate content while using the Production 
  Software (“<span className={`${styles.Bold} mb-0`}>User Content</span>”), and 
  shall grant a non-exclusive, royalty free, transferable and sub-licensable 
  licence to use, generate and/or store the User Content for the sole purpose of 
  providing its services to the User. 
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>3.6</span>	- FirstSlate’s third party licensors have the right to directly 
  enforce their rights against the User if infringed.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>4.	Restrictions of Use</span>
  </h3>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>4.1</span>	- Unless explicitly 
  stated otherwise by us, the User shall not:
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>4.1.1</span>	- modify or create 
    any derivative works of the Production Software;
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>4.1.2</span>	- distribute the 
    Production Software or any modification or derivative work; or
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>4.1.3</span>	- sell or 
    otherwise exploit the code, content, data or material.
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>4.2</span>	- The User shall
   not reverse engineer, decompile, data mine or disassemble the 
  Production Software or any of the underlying code.
  </h5>
  <h5 className="mt-3">
  <span className={`${styles.Bold} mb-0`}>4.3</span>	- Upon uploading 
  content, the User represents and warrants, to the fullest extent as permitted 
  by the laws of Ireland, that the User Content:
  </h5>
  <h5 className="mt-3 pl-5">
  <span className={`${styles.Bold} mb-0`}>4.3.1</span>	- does not infringe 
  third-party intellectual property rights;
  </h5>
  <h5 className="mt-3 pl-5">
  <span className={`${styles.Bold} mb-0`}>4.3.2</span>	- complies with the 
  General Data Protection Regulation (EU) 2016/679 (“GDPR”) 
  and/or Data Protection Act 2018 (as amended);
  </h5>
  <h5 className="mt-3 pl-5">
  <span className={`${styles.Bold} mb-0`}>4.3.3</span>	- does not contain 
  viruses or other harmful data; and
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>4.3.4</span>	- does no contain 
    material that is invasive of privacy, abusive, threatening, 
    harassing, provocative, unlawful, libellous, 
    defamatory, fraudulent or otherwise objectionable.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>4.4</span>	- The Primary User 
    should not share their access credentials with others, 
    including Administrative Users and Crew Users. Each User is responsible for 
    ensuring confidentiality and should contact us if a security incident occurs.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>4.5</span>	- FirstSlate 
    has discretion to terminate or suspend Subscriptions 
    and/or licences if this Clause 4 is not complied with.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>5.	Warranties</span>
  </h3>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>5.1</span>	- The User represents 
    and warrants compliance with Clause 4.3.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>5.2</span>	- To the fullest 
    extent permitted by the laws of Ireland, we make no representation or 
    warranty, express or implied that the Production Software is: 
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>5.2.1</span>	- fit for a 
    particular purpose;
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>5.2.2</span>	- free of 
    malware, viruses or other harmful components.
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>5.2.3</span>	- free of any 
    material that may be infringing of intellectual property. 
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>5.3</span>	- To the fullest 
    extent permitted by the laws of Ireland, no implied warranties 
    arise in the course of dealing, performance, usage or otherwise. 
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>5.4</span>	- We make no 
    warranties for any modifications, derivative works or other unauthorised 
    usage of the Production Software.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>5.5</span>	- No warranties exist, 
    express or implied, regarding any third-party service provider 
    or the User’s computer, browser and/or operating system. 
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>5.6</span>	- FirstSlate 
    shall update the Production Software from t
    ime to time. No representation or warranty is made, express or implied, 
    regarding continued existence of content, features or services.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>6.	Right to Withdraw</span>
  </h3>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>6.1</span>	- Primary Users have 
    the right to withdraw, without providing a 
    reason before the end of the Free Trial Period. For the avoidance of doubt, 
    the Free Trial Period operates as a cooling-off period whereby Users may withdraw 
    from the contract without having to make any payment.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>6.2</span>	- The right to 
    withdraw (under this Clause 6) may be exercised by 
    clicking the “Cancel” button located in the "Subscriptions” page.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>6.3</span>	- The right to 
    withdraw in this Clause 6 will expire 30-days 
    after the acceptance of the Terms. If a Primary User wishes to 
    cancel or end their Subscription after this 30-day period, when 
    the first payment has been made, Clause 9.3 shall apply to such cancellation. 
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>7.	Liability Limitation</span>
  </h3>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>7.1</span>	- Subject to 
    this Clause 7, and to the fullest extent permitted by the laws of Ireland, 
    FirstSlate, along with any directors, employees, contractors, 
    partners or affiliates, irrespective of negligent acts or omissions, 
    are not liable for indirect, special and consequential damages.
     Among other things, no liability shall arise from loss of data, 
     loss of property, damage to property, loss of profits and loss of business.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>7.2</span>	- Clause 7.1 shall 
    not apply to the extent FirstSlate is responsible for gross negligence, 
    fraudulent misrepresentation, death or personal injury. 
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>8.	Dispute Resolution</span>
  </h3>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>8.1</span>	- Please 
    contact FirstSlate via the Service Desk in the 
    event you have any issues with the Production Software.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>8.2</span>	- The terms, 
    their subject matter and their formation, are governed by 
    Irish law, and the courts of Ireland will have exclusive jurisdiction. 
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>8.3</span>	- In the event a 
    court finds anything in the Terms unenforceable, insofar 
    as possible, the remaining provisions will be upheld and enforced.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>9.	Termination and Survival</span>
  </h3>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>9.1</span>	- In the event of 
    termination under this Clause 9, the licence granted 
    to the Primary User, and any of its Administrative Users or Crew Users 
    Production Software, shall cease. 
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>9.2</span>	- We may suspend or 
    terminate a Subscription and/or User 
    licence, without prior notice, in accordance with Clause 4.5.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>9.3</span>	- Without prejudice 
    to Clause 6, Primary Users can cancel 
    their Subscription by clicking the “Cancel” button in the 
    "Subscriptions” page. Non-payment of the Subscription payment 
    shall also result in termination.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>9.4</span>	- We reserve the 
    right, alongside other instances referred to 
    in this Clause 9, to terminate licences if a decision is made to 
    discontinue the Production Software, provided reasonable notice is provided.
  </h5>
  <h5 className="mt-3">
   <span className={`${styles.Bold} mb-0`}>9.5</span>	- Following the 
   licence termination or suspension of an Administrative 
    User or Crew User, the Primary User, and other Users, may continue using 
    the services provided they have each complied with Clauses 4.1-4.3.
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>9.6</span>- Primary Users 
    retain discretion to terminate or suspend licences 
    held by Administrative Users or Crew Users. Without prejudice to 
    Clause 9.2, Primary Users may also terminate licences upon 
    obtaining knowledge of any breach of the Terms. 
  </h5>
  <h5 className="mt-3">
    <span className={`${styles.Bold} mb-0`}>9.7</span>	- Clauses 3-5 and 
    Clauses 7-9 shall survive termination and remain fully applicable. 
  </h5>
  </Col>
  </Row>
  </div>
  </>;
}